import { render } from "./AccessibilityView.vue?vue&type=template&id=639eda6b"
import script from "./AccessibilityView.vue?vue&type=script&lang=js"
export * from "./AccessibilityView.vue?vue&type=script&lang=js"

import "./AccessibilityView.vue?vue&type=style&index=0&id=639eda6b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__